import { Transform } from '@warp-drive/legacy/serializer/transform';

export default class MediaEmbedConfogTransform extends Transform {
  deserialize(serialized) {
    const json = JSON.parse(serialized);

    json.youtubeDataProtection ??=
      json.youtubeDataProtection === 'youtube-nocookie' ? true : false;

    return json;
  }

  serialize(deserialized) {
    deserialized.youtubeDataProtection = deserialized.youtubeDataProtection
      ? 'youtube-nocookie'
      : 'youtube';

    return JSON.stringify(deserialized);
  }
}
